export function formFieldsContainBookit(formFields) {
  return formFields.find(({ name }) => name === 'ld_bookit_log_id') !== undefined;
}

// Updates existing formData with new properties from bookit
// The script internally fills ld_bookit_log_id and we then submit this update to hubspot
export function composeBookitPayload(payload, bookitResponse) {
  const {
    responseData: { formInput = {} },
  } = bookitResponse;
  return Object.keys(payload).reduce((bucket, key) => {
    bucket[key] = formInput[key] || payload[key];
    return bucket;
  }, {});
}
